import { useSelector } from 'react-redux'
import { selectTerritoryLicensingLimits } from '@/features/domain/territory'
import { useIsSimulation } from '@/hooks'
import { useTexts } from '../../../../../hooks/useTexts'
import { useMemo } from 'react'

export function useTooltipTitle({
  editing,
  isLoading,
  canAddNewVehicle,
}: {
  editing: boolean
  isLoading: boolean
  canAddNewVehicle: boolean
}) {
  const { vehiclesOps, vehiclesSim } = useSelector(selectTerritoryLicensingLimits)

  const texts = useTexts()
  const isSimulation = useIsSimulation()

  return useMemo(() => {
    if (editing) {
      return texts.disabledTooltipTitle(isSimulation)
    }

    if (isLoading) {
      return texts.disabledForLoadingTooltipTitle
    }

    return canAddNewVehicle
      ? texts.canAddVehicle(isSimulation ? vehiclesSim : vehiclesOps)
      : texts.cannotAddVehicle
  }, [texts, vehiclesOps, vehiclesSim, isSimulation])
}
